import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { KEYWORD_SERVICE_PAGES, keywordServiceHead } from "@/lib/keywordServicePages";

export const Route = createFileRoute("/business-photography-videography-colorado")({
  head: () => keywordServiceHead(KEYWORD_SERVICE_PAGES.photoVideo),
  component: () => <KeywordServiceLanding page={KEYWORD_SERVICE_PAGES.photoVideo} />,
});
